// Copyright 2026 Bitech.id. Licensed under the MIT License.

import { record } from 'rrweb';

const CHECKOUT_EVERY_MS = 60_000;

export interface RecorderOptions {
  /** Default false — text is recorded as-is (LogRocket-style: what the user saw is what replays). Set true to mask all text nodes (per-element opt-out via the 'biwave-unmask' class). */
  maskAllText: boolean;
  onEvent: (event: unknown, isCheckout: boolean) => void;
}

/**
 * Thin wrapper around rrweb's record() — records the UI as the user saw it
 * (LogRocket-style). Only password input values are masked; that one is
 * never negotiable. Canvas is not recorded.
 */
export function startRecorder(options: RecorderOptions): () => void {
  const stop = record({
    emit(event, isCheckout) {
      options.onEvent(event, Boolean(isCheckout));
    },
    checkoutEveryNms: CHECKOUT_EVERY_MS,

    // Replay shows what the user saw — only passwords are masked, always.
    // When maskAllText is opted into, the 'biwave-unmask' escape hatch is a
    // selector exclusion (rrweb has no separate "unmask class" option) — an
    // element matching it is simply never matched by maskTextSelector.
    maskAllInputs: false,
    maskTextSelector: options.maskAllText ? '*:not(.biwave-unmask)' : undefined,
    maskInputOptions: {
      password: true,
    },
    blockClass: 'biwave-block',
    maskTextClass: 'biwave-mask',
    ignoreClass: 'biwave-ignore',
    recordCanvas: false,
  });

  return stop ?? (() => {});
}
